import React, { useState, useContext, useEffect, useImperativeHandle, forwardRef, useRef } from 'react';
import API from '@api/api.js';
import { message, Modal } from 'antd';
// import MemberPackage from '../memberPackage/memberPackage';
import MemberPackage from './MemberPackage';
import { useNavigate } from 'react-router-dom';
import eventBus from '@utils/eventBus';
import OneTimePay from "@view/compoents/oneTimePay/oneTimePay";
import PSAIModal from '@PSAIComponents/PSAIModal';
import Customized from '@view/compoents/customized';
import styles from './payModal.module.scss'
import Utils from '@utils/utils';
import { AppContext } from '@utils/AppContext';

const PayModal = forwardRef((props, ref) => {
    const navigate = useNavigate()
    const { rechargeModel, setRechargeModel } = useContext(AppContext);
    const [alipayOpen, setAlipayOpen] = useState(false)
    const [alipayItems, setAlipayItems] = useState()
    const [isPowerPackage, setIsPowerPackage] = useState(false)
    const [alipayDefaultSelectedIndex, setAlipayDefaultSelectedIndex] = useState(0)
    const closeCallbackRef = useRef()
    const { serviceType, serviceTypeForFree, segmentedValue, OneTimePayDisabled } = props

    useImperativeHandle(ref, () => ({
        openrechargeClick,
    }));

    const openrechargeClick = (callback) => {
        closeCallbackRef.current = callback
        setRechargeModel(true)
    }

    useEffect(() => {
        if (!rechargeModel) {
            if (closeCallbackRef.current && typeof closeCallbackRef.current == 'function') {
                closeCallbackRef.current()
                closeCallbackRef.current = null
            }
        }
    }, [rechargeModel])

    const openModalToPay = (item) => {
        if (item.level != 'free') {
            // 需要登录
            const status = Utils.checkLoginStatus(() => openModalToPay(item))
            if (!status) return

            eventBus.emit('pc_prepay', item, false, 0, () => {
                eventBus.emit('updateUserInfo')
                eventBus.emit('getUserOrgInfo')
            }, () => setRechargeModel(false))
        } else {
            setRechargeModel(false)
            message.info('欢迎免费试用')
        }
    }



    return (
        <PSAIModal
            open={rechargeModel}
            footer={null}
            maxWidth={1152}
            onCancel={() => setRechargeModel(false)}
        >
            <div className={styles.payModalWrap}>
                <div className="_beauty_scrollbar" style={{ paddingRight: '4px' }}>
                    <p className={styles.bigTitle}>超值会员方案 团队协作<span>年卡</span>更优惠</p>
                    {
                        serviceType && (
                            serviceTypeForFree ?
                                <p className={styles.payModalWrap_P}>
                                    <span>普通会员可享2张免费作图机会</span>
                                    <span>升级Pro Max或Ultra会员解锁更多额度</span>
                                </p> :
                                <p className={styles.payModalWrap_P}>升级Max/Ultra会员，即刻享受专属服务助手</p>
                        )
                    }
                    <MemberPackage />
                </div>
            </div>
        </PSAIModal>
    )
})

export default PayModal